import {
  Banner,
  Box,
  Page,
  PageBody,
  PageHeader,
  PageHeaderDescription,
  PageHeaderTitle,
  Panel,
  PanelSection,
  Spinner,
} from '@customerio/pluma-components/react';
import { DocumentTitle } from '@/components/page/document-title';
import { useCurrentWorkspace } from '@/context/current-workspace';
import { useMParticleIntegration } from '@/services/db/mparticle-integration/queries';
import { MParticleConnector } from './components/mparticle-connector';
import { MParticleHeaderTitle } from './components/mparticle-header-title';
import { useMParticleBreadcrumbs } from './hooks';

const PAGE_TITLE = 'mParticle source';

const PAGE_DESCRIPTION =
  'mParticle is a customer data platform, allowing marketers to integrate and orchestrate their entire growth ' +
  "stack so they win in key moments of the customer journey. With Customer.io as an mParticle Source, we'll send " +
  'Email, SMS, and Push events as they occur in real time.';

/**
 * The `/integrations/mparticle_out` page: connect the workspace to mParticle,
 * then choose which message events to forward.
 *
 * The header renders while the record loads, as it did in Ember — only the panel
 * waits, because the panel is what the record decides the shape of.
 */
export default function MParticleConnectorPage() {
  const workspace = useCurrentWorkspace();
  const integration = useMParticleIntegration();

  useMParticleBreadcrumbs(String(workspace?.id ?? ''));

  return (
    <>
      <DocumentTitle title={PAGE_TITLE} />
      <Page>
        <PageHeader>
          <PageHeaderTitle>
            <MParticleHeaderTitle title={PAGE_TITLE} />
          </PageHeaderTitle>
          <PageHeaderDescription>{PAGE_DESCRIPTION}</PageHeaderDescription>
        </PageHeader>

        <PageBody>
          {integration.isError ? (
            <Banner
              variant="critical"
              title="We couldn't load this integration"
              description="Refresh the page to try again."
            />
          ) : integration.isPending ? (
            <Panel withSectionBorders>
              <PanelSection>
                <Box textAlign="center" p="300">
                  <Spinner />
                </Box>
              </PanelSection>
            </Panel>
          ) : (
            // Remount on connect or disconnect: the settings draft is seeded from
            // the record, so a new record must start from a new draft.
            <MParticleConnector key={integration.data?.id ?? 'not-connected'} integration={integration.data ?? null} />
          )}
        </PageBody>
      </Page>
    </>
  );
}
